import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { terraProxyApiClient } from '../../../../clients/testerClient';
import { SURFACE_ASSETS_KEY } from '../../../../hooks/api/useSurfaceAssets';
import {
  toInternalAssetsSearchKindCounts,
  toInternalAssetsSearchTerm,
} from './internal-assets-table.model';

export function useInternalAssetsSearchKindCounts({
  networkId,
  search,
}: {
  networkId: string;
  search: string;
}) {
  const term = toInternalAssetsSearchTerm(search);
  const enabled = Boolean(networkId) && term !== null;

  const adGroupsQuery = useQuery({
    queryKey: [
      SURFACE_ASSETS_KEY,
      'internal-ad-search-kind-counts',
      networkId,
      term,
    ],
    queryFn: async () => {
      const page = await terraProxyApiClient.searchInternalNetworkAdEntities({
        networkId,
        term: term ?? '',
        limit: 1,
        groupBy: 'entityKind',
      });

      return page.groups ?? null;
    },
    enabled,
  });
  const canonicalTotalQuery = useQuery({
    queryKey: [
      SURFACE_ASSETS_KEY,
      'internal-canonical-search-total',
      networkId,
      term,
    ],
    queryFn: async () => {
      const page =
        await terraProxyApiClient.searchCanonicalInternalNetworkAssets({
          networkId,
          query: { limit: 1, search: term ?? '' },
        });

      return page.total;
    },
    enabled,
  });

  const adGroups = adGroupsQuery.data;
  const canonicalTotal = canonicalTotalQuery.data;

  return useMemo(
    () =>
      enabled && adGroups && canonicalTotal !== undefined
        ? toInternalAssetsSearchKindCounts({ adGroups, canonicalTotal })
        : null,
    [adGroups, canonicalTotal, enabled],
  );
}
